var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"options":_vm.locales,"value":_vm.userLanguage,"clearable":false},on:{"input":_vm.changeLanguage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }